import React, { useState, useEffect } from "react";
import { useChat } from "../contexts/ChatProvider";
import { useLocale } from "../contexts/LocaleProvider";
import {
  MinChatUiProvider,
  MainContainer,
  MessageContainer,
  MessageHeader,
} from "@minchat/react-chat-ui";
import MessageInput from './message-input';
import MessageList from "./message/MessageList";
import CrossIcon from './icons/CrossIcon';
import FullScreenIcon from "./icons/FullScreenIcon";
import NewChatIcon from "./icons/newChatIcon";
import MenuIcon from "./icons/MenuIcon";
import ChatMenu from "./chat-menu/MenuModal";
import ChatSessionPanel from "./chat-sessions/SessionList";
import ChatListIcon from "./icons/ChatListIcon";
import Tooltip from "./ToolTip";

export const MinimizedAndMobileWidget = ({ remoteName = "", onSend, onScreenExpand }) => {
  const {
    hide,
    theme,
    colorSet,
    loading,
    header,
    shoji,
    showTypingIndicator,
    enterFullScreen,
    isMobile,
    sessionExpired,
    handleClickNewChat,
    openChatMenu,
    setOpenChatMenu,
    showChatList,
    setSessions,
    setSessionListIndex,
    setShowChatList,
  } = useChat();
  const { t } = useLocale();
  const handleEnterFullScreen = () => {
    enterFullScreen();
    onScreenExpand();
    setSessionListIndex(0);
    setSessions([]);
  }

  return (
    <div className="chatbot-container shadow-gray-400 shadow-md relative md:w-96 bg-white rounded-xl shadow-md shadow-gray-400 md:mr-6">
      <MinChatUiProvider
        theme={theme}
        colorSet={colorSet}
      >
        <MainContainer>
          <MessageContainer>
            <MessageHeader showBack={false}>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "0 2%" }}>
                <p id="ChatBotTitle" style={{ paddingLeft: "5px" }}>
                  {header}
                </p>
                <div style={{ display: "flex", justifyContent: "start", gap: isMobile ? "10px" : "5px" }}>
                  <Tooltip text={t("header.newChatTooltip")} >
                    <span
                      className="header-action"
                      onClick={showTypingIndicator ? undefined : handleClickNewChat}
                      aria-disabled={showTypingIndicator}
                      style={{
                        "--theme-color": theme,
                        borderRadius: "50%",
                        height: "24px",
                        width: "24px",
                        cursor: showTypingIndicator ? "wait" : "pointer",
                        opacity: showTypingIndicator ? 0.5 : 1,
                      }}
                    >
                      <NewChatIcon color={colorSet["--message-header-text-color"] ?? "black"} />
                    </span>
                  </Tooltip>
                  <Tooltip text={t("header.chatsTooltip")} >
                    <span
                      className="header-action"
                      onClick={() => setShowChatList(true)}
                      style={{ 
                        "--theme-color": theme, 
                        borderRadius: '50%', 
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <ChatListIcon color={colorSet["--message-header-text-color"] ?? "black"} />
                    </span>
                  </Tooltip>
                  {!isMobile && (
                    <Tooltip text={t("header.enterFullScreenTooltip")} >
                      <span
                        className="header-action"
                        onClick={handleEnterFullScreen}
                        style={{ "--theme-color": theme, cursor: 'pointer', borderRadius: '50%' }}
                      >
                        <FullScreenIcon color={colorSet["--message-header-text-color"] ?? "black"} />
                      </span>
                    </Tooltip>
                  )}
                  <Tooltip text={t("common.close")} >
                    <span
                      className="header-action"
                      onClick={() => { hide() }}
                      style={{ "--theme-color": theme, cursor: 'pointer', borderRadius: '50%', zIndex: 10 }}
                    >
                      <CrossIcon color={colorSet["--message-header-text-color"] ?? "black"} />
                    </span>
                  </Tooltip>
                </div>
              </div>
            </MessageHeader>
            <MessageList
              loading={loading}
            >
            </MessageList>
            <MessageInput
              placeholder={shoji() ? "ここにメッセージを入力してください" : t("chat.default_input_placeholder")}
              onSendMessage={onSend}
              showAttachButton={false}
              disabled={showTypingIndicator}
            />
          </MessageContainer>
          {showChatList && <ChatSessionPanel />}
        </MainContainer>
      </MinChatUiProvider>
    </div >

  );
};